import { useI18n } from "@/lib/i18n";

const LogoSlider = () => {
  const { lang, t } = useI18n();
  const brands = t.refs.items[lang].map((r) => r.name);
  // Duplicate the list so the marquee loops seamlessly
  const loop = [...brands, ...brands];

  return (
    <section
      aria-label={t.refs.label[lang]}
      className="py-10 md:py-12 bg-background border-y border-border overflow-hidden"
    >
      <div className="container mx-auto px-6 max-w-[960px] mb-5">
        <div className="section-label text-center">{t.refs.label[lang]}</div>
      </div>

      <div
        className="relative w-full overflow-hidden"
        style={{
          maskImage:
            "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
        }}
      >
        <div className="flex w-max animate-marquee gap-12 md:gap-16">
          {loop.map((name, i) => (
            <div
              key={i}
              className="shrink-0 font-display text-lg md:text-xl tracking-[0.18em] uppercase text-muted-foreground/80 hover:text-brand-blue transition-colors whitespace-nowrap"
            >
              {name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoSlider;
